// extracted by mini-css-extract-plugin
export default {"rest_planet":"style_rest_planet__0JeK8"};